<template>
    <div>
        <div class="YesNoContainer"
             style="margin-top: 28px; display: flex;">
            <div :class="{ primary: isLiked, 'validation-error': hasError }"
                 class="YesDiv me-3"
                 @click="toggleLike">
                <div class="mdi-container">
                    <button class="icon-button">
                        <!--<i :class="['mdi', 'mdi-24px', likeIconClass]"></i>-->
                        <img src="../../assets/images/thumbs-up.png"/>
                    </button>
                </div>
                <div class="label-choice-content">
                    <p>{{$t('Yes')}}</p>
                </div>
            </div>
            <div :class="{ error: isDisliked, 'validation-error': hasError }"
                 class="NoDiv me-3"
                 @click="toggleDislike">
                <div class="mdi-container">
                    <button class="icon-button">
                        <!--<i :class="['mdi', 'mdi-24px', dislikeIconClass]"></i>-->
                        <img src="../../assets/images/thumbs-down.png" />
                    </button>
                </div>
                <div class="label-choice-content">
                    <p>{{$t('No')}}</p>
                </div>
            </div>
        </div>
        <div v-if="hasError" class="error-message">
            {{errorMessage}}
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: String,
            error: {
                type: Boolean,
                default: false
            },
            errorMessage: {
                type: String,
                default: 'This field is required'
            }
        },
        data() {
            return {
                isLiked: this.value === 'yes',
                isDisliked: this.value === 'no'
            }
        },
        computed: {
            likeIconClass() {
                return this.isLiked ? 'mdi-thumb-up' : 'mdi-thumb-up-outline'
            },
            dislikeIconClass() {
                return this.isDisliked ? 'mdi-thumb-down' : 'mdi-thumb-down-outline'
            },
            hasError() {
                return this.error && !this.value
            }
        },
        watch: {
            value(newValue) {
                this.isLiked = newValue === 'yes'
                this.isDisliked = newValue === 'no'
            }
        },
        methods: {
            toggleLike(event) {
                event.preventDefault()
                if (!this.isLiked) {
                    this.isLiked = true
                    this.isDisliked = false
                } else {
                    this.isLiked = false
                }
                this.$emit('input', this.isLiked ? 'yes' : 'no')
            },
            toggleDislike(event) {
                event.preventDefault()
                if (!this.isDisliked) {
                    this.isDisliked = true
                    this.isLiked = false
                } else {
                    this.isDisliked = false
                }
                this.$emit('input', this.isDisliked ? 'no' : 'yes')
            }
        }
    }
</script>

<style scoped>
    .YesNoContainer {
   
        cursor: pointer;
        outline: none;
    }

    .YesDiv,
    .NoDiv {
        width: 80px;
        position: relative;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        transition: all 0.3s ease 0s;
        outline: none;
        border: 1px solid rgba(63, 63, 63, 0.5);

    }

    .YesDiv.validation-error,
    .NoDiv.validation-error {
        border: 2px solid #ff5252;
        animation: shake 0.5s;
    }

    @keyframes shake {
        0%, 100% { transform: translateX(0); }
        10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
        20%, 40%, 60%, 80% { transform: translateX(5px); }
    }

    .error-message {
        color: #ff5252;
        font-size: 12px;
        margin-top: 4px;
        margin-left: 12px;
    }

    .icon-button {
        margin: 5px;
    }

    .YesDiv.primary,
    .NoDiv.primary {
        background-color: rgba(63, 63, 63, 0.2);
        z-index: 1;
        color:white;
    }
    .label-choice-content{
        font-size:14px;
        font-weight:700;
    }
</style>
